module.exports = __webpack_public_path__ + "resources/846e29413d904668b0f43d477a328b2c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/super-hero.png
// module id = 223
// module chunks = 0